// Runtime config — see env-config.template.js and the template README.
type AppConfig = {
  apiUrl: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

export const config: AppConfig = {
  apiUrl: window.__APP_CONFIG__?.apiUrl || '',
};
